import type { ReactNode } from 'react';

export const symbol_turn_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-190v-338q0-25 17.5-42.5T340-588h386l-69-69q-9-9-9-21t9-21q9-9 21-9t21 9l120 120q9 9 9 21t-9 21L699-417q-9 9-21 9t-21-9q-9-9-9-21t9-21l69-69H340v338q0 13-8.5 21.5T310-160q-13 0-21.5-8.5T280-190Z"
		/>
	</svg>
);
